import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../context/User';
import App from '../App';
import Footer from './Footer';
import Header from './Header';

const AUTH_ROUTES = ['/login', '/register', '/reset', '/user/reset'];

const isAuthRoute = (pathname) => {
  const normalizedPath =
    pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return (
    AUTH_ROUTES.includes(normalizedPath) ||
    normalizedPath === '/oauth' ||
    normalizedPath.startsWith('/oauth/')
  );
};

const AppShell = () => {
  const [userState] = useContext(UserContext);
  const location = useLocation();
  const authRoute = isAuthRoute(location.pathname);
  const showHeader = !authRoute && Boolean(userState.user);

  return (
    <div className={`app-shell${authRoute ? ' app-shell-auth' : ''}`}>
      {showHeader && <Header />}
      <div className={authRoute ? 'app-shell-auth-content' : 'main-content'}>
        <App />
      </div>
      {!authRoute && <Footer />}
    </div>
  );
};

export default AppShell;
